/**
 * SignalSelector Component
 * 
 * Dropdown component for selecting signal types from the registry.
 * Filters signals by category (entry/exit/both).
 */

import React from "react";
import { SIGNAL_REGISTRY } from "../../../../../config/signals";
import styles from "./SignalSelector.module.css";

interface SignalSelectorProps {
  value: string;
  onChange: (signalType: string) => void;
  category: "entry" | "exit";
  disabled?: boolean;
  allowedSignalTypes?: string[];
}

export const SignalSelector: React.FC<SignalSelectorProps> = ({
  value,
  onChange,
  category,
  disabled = false,
  allowedSignalTypes,
}) => {
  // Filter signals by category
  const allowedSet = allowedSignalTypes ? new Set(allowedSignalTypes) : null;
  const availableSignals = Object.values(SIGNAL_REGISTRY).filter(
    (signal) =>
      (signal.category === category || signal.category === "both") &&
      (!allowedSet || allowedSet.has(signal.key))
  );

  return (
    <select
      className={styles.selector}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    >
      <option value="">Select signal...</option>
      {availableSignals.map((signal) => (
        <option key={signal.key} value={signal.key}>
          {signal.label}
        </option>
      ))}
    </select>
  );
};
